import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";

const PrivateRoutes: React.FC = () => {
  const isAuthenticated = Boolean(localStorage.getItem("e-user"));
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login and save current location in state
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If authenticated, render the nested routes
  return <Outlet />;
};

export default PrivateRoutes;
